

const testQuestionsActions = {
    types: {
        SET_NEXT_QUESTION_ID: 'SET_NEXT_QUESTION_ID',
    },

    setNextQuestionId(questionId, nextQuestionRevisionId) {
        return { type: this.types.SET_NEXT_QUESTION_ID, questionId, nextQuestionRevisionId };
    },
};

export default testQuestionsActions;
